module.exports = __webpack_public_path__ + "img/ruhani-logo.9541eeb1.svg";